import { jsonPost, put } from '@client/lib/request';

export const sendConfirmationEmail = ({ token }) => jsonPost('/mylounge-api/customer/send-confirmation-email', { token });

export const saveCountry = ({ country }) => put('/mylounge-api/customer/preferred-country', { preferredCountry: country });
